import React from 'react';
import Api from "../../servicios/api";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faTimes, faArrowRight, faAngleDoubleLeft, faAngleLeft, faAngleDoubleRight, faAngleRight } from '@fortawesome/free-solid-svg-icons'

class Pacientes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            datosCargados: false,
            pagina: [],
            pacientes: []
        }
    }
    resetForm() {
        document.getElementById('bnombre').value = "";
        document.getElementById('bidentificacion').value = "";
        document.getElementById('bnombre').focus();
        this.BuscarPaciente(1);
    }
    enviarPaciente = (sidp,doc, snombre, sapellido,dir) => {
        console.log(sidp, snombre, sapellido);
        document.getElementById('id_paciente').value = sidp;
        document.getElementById('doc').value = doc;
        document.getElementById('direccion_paciente').value = dir;
        document.getElementById('nombre_paciente').value = snombre + " " + sapellido;
        //this.props.agregarPaciente(sidp, snombre + " " + sapellido);
        window.$('#asignarPaciente').modal('hide');
    }
    componentDidMount() {
        this.BuscarPaciente(1);
    }
    BuscarPaciente(page) {
        let bnombre = document.getElementById('bnombre').value;
        let bidentificacion = document.getElementById('bidentificacion').value;
        console.log("Formulario Enviado...");
        if (bnombre == '') {
            bnombre = 0;
        }
        if (bidentificacion == '') {
            bidentificacion = 0;
        }
        fetch(Api + "SearchPacientes/" + bidentificacion + "/" + bnombre + "/0?page=" + page)
            .then((respuesta) => respuesta.json())
            .then((datosRespuesta) => {
                this.setState({ datosCargados: true, pacientes: datosRespuesta.data, pagina: datosRespuesta.total, ultimo: datosRespuesta.last_page, actual: datosRespuesta.current_page });
            })
            .catch(console.log);
    }
    render() {
        const { datosCargados, pacientes, pagina, ultimo, actual } = this.state;
        if (!datosCargados) {
            var load = 'Cargando datos....';
        } else {
            var load = '';
        }
        return (
            <div className="modal-dialog modal-lg modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="nuevaEnfermedad1Label">Pacientes</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="card">
                            <div style={{ backgroundImage: 'linear-gradient(#2FB3FB, #003153)', color: '#FFFFFF', borderTopLeftRadius: 5, borderTopRightRadius: 5 }} className="card-header text-center">
                                <h5 style={{ fontSize: 18 }} >Lista de Pacientes</h5>
                            </div>
                            <div className='card-body'>
                                <div className="row">
                                    <div className="col-xl-5">
                                        <input type="text" id="bnombre" name="bnombre" placeholder="Nombre Paciente" className="form-control form-control-sm" />
                                    </div>
                                    <div className="col-xl-3">
                                        <input type="text" id="bidentificacion" name="bidentificacion" placeholder="Documento" className="form-control form-control-sm" />
                                    </div>
                                    <div className="col-xl-4">
                                        <button type="button" className="btn btn-primary btn-sm" onClick={() => this.BuscarPaciente(1)}><FontAwesomeIcon icon={faSearch} />&nbsp;&nbsp;Buscar</button>&nbsp;&nbsp;
                                        <button type="button" className="btn btn-danger btn-sm" onClick={() => this.resetForm()} ><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</button>
                                    </div>
                                </div>
                                <br></br>
                                <div className="row">
                                    <table className="table table-hover table-condensed table-sm">
                                        <thead className="thead-inverse">
                                            <tr>
                                                <th>CEDULA</th>
                                                <th>PACIENTE</th>
                                                <th>SEXO</th>
                                                <th>TELEFONO</th>
                                                <th>SELECCIONAR</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {load}
                                            {pacientes.map((itemPaciente) => (
                                                <tr key={itemPaciente.id_paciente}>
                                                    <td>{itemPaciente.numero_doc}</td>
                                                    <td>{itemPaciente.nombres} {itemPaciente.apellidos} </td>
                                                    <td>{itemPaciente.sexo}</td>
                                                    <td>{itemPaciente.tel_1}</td>
                                                    <td>
                                                        <div className="btn-group" role="group" aria-label="">
                                                            <button type="button" className="btn btn-primary btn-sm" onClick={() => this.enviarPaciente(itemPaciente.id_paciente,itemPaciente.numero_doc, itemPaciente.nombres, itemPaciente.apellidos, itemPaciente.direccion1)}><FontAwesomeIcon icon={faArrowRight} /></button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="row">
                                    <div className='col-xs-12'>
                                        <nav aria-label="Page navigation example">
                                            <ul className="pagination">
                                                <li className="page-item"><a className="page-link" href="#" onClick={() => this.BuscarPaciente(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                                <li className="page-item"><a className="page-link" href="#" onClick={() => this.BuscarPaciente(actual - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                                {(() => {
                                                    let p = [];
                                                    /*if (ultimo >= 86) {
                                                        var ult = 86;
                                                    } else {
                                                        ult = ultimo;
                                                    }
                                                    for (let i = 1; i <= ult; i++) {
                                                        p.push(<li className="page-item" key={i}><a className="page-link" href="#" onClick={() => this.BuscarPaciente(i)}>{i}</a></li>);
                                                    }*/
                                                    p.push(<li className="page-item" key={actual}><a className="page-link" href="#" onClick={() => this.BuscarPaciente(actual)}>{actual}</a></li>);
                                                    return p;
                                                })()}
                                                <li className="page-item"><a className="page-link" href="#" onClick={() => this.BuscarPaciente(actual + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                                <li className="page-item"><a className="page-link" href="#" onClick={() => this.BuscarPaciente(ultimo)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                            </ul>
                                        </nav>
                                    </div>
                                    <div className="card-footer text-muted">
                                        <b>Pagina</b> <span class="badge bg-primary">{actual}</span> <b>de</b> <span class="badge bg-primary">{ultimo}</span> | <b>Registros</b> <span class="badge bg-success">{pagina}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default Pacientes;